module.exports = __webpack_public_path__ + "assets/images/intro-bg-5_cab78f5166ca1b9d43423788a887ad02.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/intro/intro-bg-5.png
// module id = 130
// module chunks = 0